const SESSION_TOKEN_TTL_MS = 90 * 24 * 60 * 60 * 1000

// The onboarding link carries a session token. It is taken out of the address
// and kept for this browser, so the onboarding pages (and the help guides they
// open in a new tab) keep working without it in the address.
export function readOnboardingSessionToken(
  companyUid: string | undefined
): string | null {
  const storageKey = `onboarding-token-${companyUid}`
  const url = new URL(window.location.href)
  const token = url.searchParams.get('token')
  if (token) {
    url.searchParams.delete('token')
    window.history.replaceState({}, '', url.pathname + url.search + url.hash)
    try {
      localStorage.setItem(
        storageKey,
        JSON.stringify({ token, savedAt: Date.now() })
      )
    } catch {
      // best effort
    }
    return token
  }
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) ?? 'null')
    if (stored?.token && Date.now() - stored.savedAt < SESSION_TOKEN_TTL_MS) {
      return stored.token
    }
    localStorage.removeItem(storageKey)
  } catch {
    // best effort
  }
  return null
}
